
// 获取表格屏蔽列设置
export const table_check = state => state.table_check;

// 获取站点配置
export const siteConfig = state => state.siteConfig;



// WEBPACK FOOTER //
// ./src/store/getters.js